import {ReactNode} from 'react'
import {Cropper, CropperProvider} from 'widgets/cropper'

export const withCropper = (component: () => ReactNode) => () => (
  <CropperProvider>
    <Cropper />
    {component()}
  </CropperProvider>
)
